/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListMyVoucherCodesParams,
  ListVoucherCodesParams,
  PaginatedResponseVoucherCodeResponse,
  ReleaseSingleCode200,
  UseSingleCode200,
  ValidateCodeParams,
  VoucherAvailableCount,
  VoucherAvailableCountsRequest,
  VoucherValidationResponse
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * List voucher codes for a voucher (Admin only).
 * @summary List Voucher Codes
 */
export const listVoucherCodes = (
    params: ListVoucherCodesParams,
 signal?: AbortSignal
) => {


      return apiInstance<PaginatedResponseVoucherCodeResponse>(
      {url: `/api/voucher-codes/`, method: 'GET',
        params, signal
    },
      );
    }




export const getListVoucherCodesQueryKey = (params?: ListVoucherCodesParams,) => {
    return [
    `/api/voucher-codes/`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVoucherCodesQueryOptions = <TData = Awaited<ReturnType<typeof listVoucherCodes>>, TError = HTTPValidationError>(params: ListVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVoucherCodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVoucherCodes>>> = ({ signal }) => listVoucherCodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVoucherCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listVoucherCodes>>>
export type ListVoucherCodesQueryError = HTTPValidationError


export function useListVoucherCodes<TData = Awaited<ReturnType<typeof listVoucherCodes>>, TError = HTTPValidationError>(
 params: ListVoucherCodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof listVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVoucherCodes<TData = Awaited<ReturnType<typeof listVoucherCodes>>, TError = HTTPValidationError>(
 params: ListVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof listVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVoucherCodes<TData = Awaited<ReturnType<typeof listVoucherCodes>>, TError = HTTPValidationError>(
 params: ListVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Voucher Codes
 */

export function useListVoucherCodes<TData = Awaited<ReturnType<typeof listVoucherCodes>>, TError = HTTPValidationError>(
 params: ListVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVoucherCodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Return available voucher-code counts for multiple voucher IDs in one call.

Admin-only for now since it is used by admin list view.
 * @summary Get Voucher Available Counts Bulk
 */
export const getVoucherAvailableCountsBulk = (
    voucherAvailableCountsRequest: VoucherAvailableCountsRequest,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherAvailableCount[]>(
      {url: `/api/voucher-codes/available-counts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voucherAvailableCountsRequest, signal
    },
      );
    }



export const getGetVoucherAvailableCountsBulkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>, TError,{data: VoucherAvailableCountsRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>, TError,{data: VoucherAvailableCountsRequest}, TContext> => {

const mutationKey = ['getVoucherAvailableCountsBulk'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>, {data: VoucherAvailableCountsRequest}> = (props) => {
          const {data} = props ?? {};

          return  getVoucherAvailableCountsBulk(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVoucherAvailableCountsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>>
    export type GetVoucherAvailableCountsBulkMutationBody = VoucherAvailableCountsRequest
    export type GetVoucherAvailableCountsBulkMutationError = HTTPValidationError

    /**
 * @summary Get Voucher Available Counts Bulk
 */
export const useGetVoucherAvailableCountsBulk = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>, TError,{data: VoucherAvailableCountsRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVoucherAvailableCountsBulk>>,
        TError,
        {data: VoucherAvailableCountsRequest},
        TContext
      > => {
      return useMutation(getGetVoucherAvailableCountsBulkMutationOptions(options), queryClient);
    }
    /**
 * Validate a voucher code
 * @summary Validate Code
 */
export const validateCode = (
    params: ValidateCodeParams,
 signal?: AbortSignal
) => {


      return apiInstance<VoucherValidationResponse>(
      {url: `/api/voucher-codes/validate`, method: 'POST',
        params, signal
    },
      );
    }



export const getValidateCodeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCode>>, TError,{params: ValidateCodeParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateCode>>, TError,{params: ValidateCodeParams}, TContext> => {

const mutationKey = ['validateCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateCode>>, {params: ValidateCodeParams}> = (props) => {
          const {params} = props ?? {};

          return  validateCode(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateCodeMutationResult = NonNullable<Awaited<ReturnType<typeof validateCode>>>

    export type ValidateCodeMutationError = HTTPValidationError

    /**
 * @summary Validate Code
 */
export const useValidateCode = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateCode>>, TError,{params: ValidateCodeParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateCode>>,
        TError,
        {params: ValidateCodeParams},
        TContext
      > => {
      return useMutation(getValidateCodeMutationOptions(options), queryClient);
    }
    /**
 * Release an assigned voucher code (clear user assignment if not redeemed).
 * @summary Release Single Code
 */
export const releaseSingleCode = (
    codeId: string,
 signal?: AbortSignal
) => {


      return apiInstance<ReleaseSingleCode200>(
      {url: `/api/voucher-codes/${codeId}/release`, method: 'POST', signal
    },
      );
    }



export const getReleaseSingleCodeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseSingleCode>>, TError,{codeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof releaseSingleCode>>, TError,{codeId: string}, TContext> => {

const mutationKey = ['releaseSingleCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof releaseSingleCode>>, {codeId: string}> = (props) => {
          const {codeId} = props ?? {};

          return  releaseSingleCode(codeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReleaseSingleCodeMutationResult = NonNullable<Awaited<ReturnType<typeof releaseSingleCode>>>

    export type ReleaseSingleCodeMutationError = HTTPValidationError

    /**
 * @summary Release Single Code
 */
export const useReleaseSingleCode = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof releaseSingleCode>>, TError,{codeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof releaseSingleCode>>,
        TError,
        {codeId: string},
        TContext
      > => {
      return useMutation(getReleaseSingleCodeMutationOptions(options), queryClient);
    }
    /**
 * Mark a voucher code as used (Admin only).
 * @summary Use Single Code
 */
export const useSingleCode = (
    codeId: string,
 signal?: AbortSignal
) => {


      return apiInstance<UseSingleCode200>(
      {url: `/api/voucher-codes/${codeId}/use`, method: 'POST', signal
    },
      );
    }



export const getUseSingleCodeMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useSingleCode>>, TError,{codeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof useSingleCode>>, TError,{codeId: string}, TContext> => {

const mutationKey = ['useSingleCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof useSingleCode>>, {codeId: string}> = (props) => {
          const {codeId} = props ?? {};

          return  useSingleCode(codeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UseSingleCodeMutationResult = NonNullable<Awaited<ReturnType<typeof useSingleCode>>>

    export type UseSingleCodeMutationError = HTTPValidationError

    /**
 * @summary Use Single Code
 */
export const useUseSingleCode = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof useSingleCode>>, TError,{codeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof useSingleCode>>,
        TError,
        {codeId: string},
        TContext
      > => {
      return useMutation(getUseSingleCodeMutationOptions(options), queryClient);
    }
    /**
 * List voucher codes owned by the current user.
 * @summary List My Voucher Codes
 */
export const listMyVoucherCodes = (
    params?: ListMyVoucherCodesParams,
 signal?: AbortSignal
) => {


      return apiInstance<PaginatedResponseVoucherCodeResponse>(
      {url: `/api/voucher-codes/mine`, method: 'GET',
        params, signal
    },
      );
    }




export const getListMyVoucherCodesQueryKey = (params?: ListMyVoucherCodesParams,) => {
    return [
    `/api/voucher-codes/mine`, ...(params ? [params] : [])
    ] as const;
    }


export const getListMyVoucherCodesQueryOptions = <TData = Awaited<ReturnType<typeof listMyVoucherCodes>>, TError = HTTPValidationError>(params?: ListMyVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMyVoucherCodesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMyVoucherCodes>>> = ({ signal }) => listMyVoucherCodes(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMyVoucherCodesQueryResult = NonNullable<Awaited<ReturnType<typeof listMyVoucherCodes>>>
export type ListMyVoucherCodesQueryError = HTTPValidationError


export function useListMyVoucherCodes<TData = Awaited<ReturnType<typeof listMyVoucherCodes>>, TError = HTTPValidationError>(
 params: undefined |  ListMyVoucherCodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof listMyVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyVoucherCodes<TData = Awaited<ReturnType<typeof listMyVoucherCodes>>, TError = HTTPValidationError>(
 params?: ListMyVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMyVoucherCodes>>,
          TError,
          Awaited<ReturnType<typeof listMyVoucherCodes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMyVoucherCodes<TData = Awaited<ReturnType<typeof listMyVoucherCodes>>, TError = HTTPValidationError>(
 params?: ListMyVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List My Voucher Codes
 */

export function useListMyVoucherCodes<TData = Awaited<ReturnType<typeof listMyVoucherCodes>>, TError = HTTPValidationError>(
 params?: ListMyVoucherCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMyVoucherCodes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMyVoucherCodesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






